/** Spell the letter prefix of a course code (e.g. "MIC420" -> "M I C 420"). */
export const spellCourseCodeForScreenReader = (code: string): string => {
  const trimmed = code.trim();
  const match = trimmed.match(/^([A-Za-z]+)(\d*)$/);
  if (!match) {
    return trimmed;
  }

  const [, letters, digits] = match;
  const spelledLetters = letters.split("").join(" ");
  return digits ? `${spelledLetters} ${digits}` : spelledLetters;
};

/** Spell slash-separated acronyms (e.g. "BIO/MIC" -> "B I O, M I C"). */
export const spellCategoryLabelForScreenReader = (label: string): string => {
  if (label === "All") {
    return label;
  }

  return label
    .split("/")
    .map((part) => spellCourseCodeForScreenReader(part.trim()))
    .join(", ");
};

export const spellCourseCodesForScreenReader = (codes: string | string[]): string => {
  const parts = Array.isArray(codes) ? codes : codes.split(/\s*\|\s*/);
  return parts
    .map((code) => spellCourseCodeForScreenReader(code.trim()))
    .filter(Boolean)
    .join(", ");
};

export const getCourseAccessibleLabel = (
  tag: string,
  courseName: string,
  subTitle?: string
): string => {
  if (tag.includes("|")) {
    return `${spellCourseCodesForScreenReader(tag)}, ${courseName}`;
  }

  return `${spellCourseCodeForScreenReader(subTitle ?? tag)}, ${courseName}`;
};
